export const NoData = () => {
    return(
        <div className="noresult">
            <div className="text-center">
                <hr style={{color: "red"}}/>
                <h5 className="mt-2" style={{color: "red"}}>Sorry! No Result Found</h5>
            </div>
        </div>
    )
}